import gallery from '@/assets/gall1.png';
import 'react-quill/dist/quill.snow.css';
import { useEffect, useState } from 'react';
import { Button } from '@/components/Elements';

const AgencyCards = () => {
  return (
    <div className="agency-card-row">
      <div className="row">
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <h6 className="dark-gray mb-0">Tranquil Haven in the Woods</h6>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Accepted Request</p>
                </div>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Request Agency</p>
                </div>
            </div>
            <Button className='rounded-full w-100 mt-3 f-13' size='sm'>View Details</Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <h6 className="dark-gray mb-0">Tranquil Haven in the Woods</h6>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Accepted Request</p>
                </div>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Request Agency</p>
                </div>
            </div>
            <Button className='rounded-full w-100 mt-3 f-13' size='sm'>View Details</Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <h6 className="dark-gray mb-0">Tranquil Haven in the Woods</h6>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Accepted Request</p>
                </div>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Request Agency</p>
                </div>
            </div>
            <Button className='rounded-full w-100 mt-3 f-13' size='sm'>View Details</Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <h6 className="dark-gray mb-0">Tranquil Haven in the Woods</h6>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Accepted Request</p>
                </div>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Request Agency</p>
                </div>
            </div>
            <Button className='rounded-full w-100 mt-3 f-13' size='sm'>View Details</Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <h6 className="dark-gray mb-0">Tranquil Haven in the Woods</h6>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Accepted Request</p>
                </div>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Request Agency</p>
                </div>
            </div>
            <Button className='rounded-full w-100 mt-3 f-13' size='sm'>View Details</Button>
          </div>
        </div>        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <h6 className="dark-gray mb-0">Tranquil Haven in the Woods</h6>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className='row'>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Accepted Request</p>
                </div>
                <div className='col-12 col-md-6'>
                    <h5 className='mb-0'>10</h5>
                    <p className='f-13'>Request Agency</p>
                </div>
            </div>
            <Button className='rounded-full w-100 mt-3 f-13' size='sm'>View Details</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AgencyCards;
